export const webinar = {
  fields: [
    { label: "First Name", id: "first_name", type: "text", component: "input", required: true },
    { label: "Last Name", id: "last_name", type: "text", component: "input", required: true },
    { label: "Company", id: "company_name", type: "text", component: "input", required: true },
    { label: "Job Title", id: "job_title", type: "text", component: "input", required: false },
    { label: "Email", id: "email", type: "email", component: "input", required: true },
    {
      label: "Describe your interest in external data",
      id: "message",
      component: "textarea",
      required: false,
    },
  ],
};
